import type { LmsCheckboxTree, LmsFilters, LmsLocationFacet } from '@/interfaces/lms';
import { toggleNestedCheckbox } from '@/lib/utils/lmsQueryParams';
import { CollapsibleContinent } from './checkbox/CollapsibleContinent';

type LmsDestinationFilterProps = {
    data?: LmsLocationFacet[];
    filters: LmsFilters;
    updateFilters: (key: string, value: LmsCheckboxTree) => void;
};

const flattenCheckboxTree = (tree: LmsCheckboxTree): string[] =>
    Object.keys(tree).flatMap((key: string) => [key, ...flattenCheckboxTree(tree[key])]);

export const LmsDestinationFilter = ({ data, filters, updateFilters }: LmsDestinationFilterProps) => {
    const checkboxTree: LmsCheckboxTree = filters.til ?? {};
    const checked: string[] = flattenCheckboxTree(checkboxTree);

    const onChange = (value: string[]): void => {
        updateFilters('til', toggleNestedCheckbox(checkboxTree, value));
    };

    const renderContinents = (continent: LmsLocationFacet) => (
        <CollapsibleContinent
            key={`destination-${continent.name.replace(' ', '_')}`}
            continent={continent}
            checked={checked}
            onChange={onChange}
        />
    );

    return data?.map(renderContinents) ?? null;
};
